module.exports = __webpack_public_path__ + "img/viz-1-key.9425dcd8.svg";